// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2iMEy","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2VnUc"};